<template>
    <div>
        <CreateSupplier />
    </div>
</template>

<script>
import CreateSupplier from '@/components/supplier/CreateSupplier.vue';
export default {
    components: {
        CreateSupplier
    },
    name: 'SupplierCreate'
}
</script>